import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import NotFound from '@/components/NotFound'

// Layouts
import Layout1 from '@/layout/Layout1'

Vue.use(Router)
Vue.use(Meta)

const router = new Router({
  base: '/',
  mode: 'history',
  routes: [
    {
      path: '/giris',
      name: 'OturumAc',
      component: () => import('@/views/auth/login')
    },
    {
      path: '/cgi-sys/defaultwebpage.cgi',
      redirect: '/'
    },
    {
      path: '/uzaktan-giris/:guid?',
      name: 'UzaktanOturumAc',
      component: () => import('@/views/auth/uzaktan-giris')
    },
    {
      path: '/muallim-giris/:guid?',
      name: 'MuallimUzaktanOturumAc',
      component: () => import('@/views/auth/muallim-giris')
    },
    {
      path: '/katil/:sinif?',
      name: 'Katil',
      component: () => import('@/views/katil')
    },
    {
      path: '/hocakayit',
      name: 'HocaKayit',
      component: () => import('@/views/auth/hocaKayit')
    },
    {
      path: '/hoca-kayit',
      name: 'Hoca-Kayit',
      component: () => import('@/views/auth/hocaKayit')
    },
    {
      path: '/bayanhocakayit',
      name: 'BayanHocaKayit',
      component: () => import('@/views/auth/hocaKayit')
    },
    {
      path: '/bayan-hoca-kayit',
      name: 'Bayan-Hoca-Kayit',
      component: () => import('@/views/auth/hocaKayit')
    },
    {
      path: '/',
      component: Layout1,
      children: [{
        path: '',
        redirect: '/anasayfa',
        component: () => import('@/views/home'),
        name: 'AnaSayfa'
      }, {
        path: 'anasayfa',
        component: () => import('@/views/home'),
        name: 'AnaSayfa'
      }, {
        path: 'kisi/liste',
        name: 'KisiListesi',
        meta: [{
          Roles: [6, 5, 4, 3, 2]
        }],
        component: () => import('@/views/kisi')
      }, {
        path: 'ogrenci/liste',
        name: 'OgrenciListesi',
        meta: [{
          Roles: [6, 5, 4, 3, 2]
        }],
        component: () => import('@/views/ogrenci')
      }, {
        path: 'sinif/liste',
        name: 'SinifListesi',
        meta: [{
          Roles: [6, 5, 4, 3, 2, 1]
        }],
        component: () => import('@/views/sinif')
      }, {
        path: 'sinif/ogrenci/:id',
        name: 'SinifOgrenciListesi',
        meta: [{
          Roles: [6, 5, 4, 3, 2, 1]
        }],
        component: () => import('@/views/sinifOgrenci')
      }, {
        path: 'sinif/grup-baskani/:id',
        name: 'SinifGrupBaskaniListesi',
        meta: [{
          Roles: [6, 5, 4, 3, 2, 1]
        }],
        component: () => import('@/views/sinifGrupBaskani')
      }, {
        path: 'sinif/yoklama/:id',
        name: 'YoklamaListesi',
        meta: [{
          Roles: [6, 5, 4, 3, 2, 1]
        }],
        component: () => import('@/views/yoklama')
      }, {
        path: 'sinif/otomatik/:id',
        name: 'OtomatikDersListesi',
        meta: [{
          Roles: [6, 5, 4, 3, 2, 1]
        }],
        component: () => import('@/views/otomatikDers')
      }, {
        path: 'sinif/ders/:id',
        name: 'SinifDersListesi',
        meta: [{
          Roles: [6, 5, 4, 3, 2, 1]
        }],
        component: () => import('@/views/sinifDers')
      }, {
        path: 'baslayacak-devam-edenler',
        name: 'BaslayacakDevamEdenler',
        meta: [{
          Roles: [6, 5, 4, 3, 2]
        }],
        component: () => import('@/views/baslayacaklarDevamEdenler')
      }, {
        path: 'eser',
        name: 'Eser',
        meta: [{
          Roles: [6, 5, 4, 3, 2, 1]
        }],
        component: () => import('@/views/eser')
      }, {
        path: 'etkinlik',
        name: 'Etkinlikler',
        meta: [{
          Roles: [6, 5, 4, 3, 2, 1]
        }],
        component: () => import('@/views/etkinlik')
      }, {
        path: 'seminer/:id?',
        name: 'seminer',
        meta: [{
          Roles: [6, 5, 4, 3, 2, 1, 0]
        }],
        component: () => import('@/views/seminer')
      }, {
        path: 'seminerler',
        name: 'seminerler',
        meta: [{
          Roles: [6, 5, 4, 3, 2, 1, 0]
        }],
        component: () => import('@/views/seminerler')
      }, {
        path: 'sertifika',
        name: 'Sertifikalar',
        component: () => import('@/views/sertifika')
      }, {
        path: 'dosyalar',
        name: 'dosyalar',
        meta: [{
          Roles: [6, 5, 4, 3, 2, 1]
        }],
        component: () => import('@/views/dosya')
      }, {
        path: 'sorular',
        name: 'Sorular',
        meta: [{
          Roles: [6, 5, 4, 3, 2]
        }],
        component: () => import('@/views/sorular')
      }, {
        path: 'online',
        name: 'online',
        meta: [{
          Roles: [6]
        }],
        component: () => import('@/views/online')
      }]
    }, {
      path: '*',
      component: NotFound
    }]
})

export default router
